import React, { useContext } from "react";
import "react-day-picker/lib/style.css";
import "moment/locale/it";
import ClockIcon from "@material-ui/icons/Schedule";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Alert } from "@material-ui/lab";
import { CountdownContext } from "../contexts/CountdownContext";
import { convertCountDown } from "../commonUtils/misc";
import { stepsByName } from "../main/specificUtils/configs";
import { makeStyles } from "@material-ui/core/styles";
import { PaymentContext } from "../contexts/PaymentContext";

const useStyles = makeStyles((theme) => ({
  alertIcon: {
    display: "flex",
    alignItems: "center",
  },
  noMargin: {
    margin: "0 !important",
  },
  timeLabel: {
    textAlign: "center",
  },
}));

function GlobalAlertTimer(props) {
  const classes = useStyles();
  const countDownETA = useContext(CountdownContext);
  const [paymentState] = useContext(PaymentContext);
  const { hours, minutes, seconds } = convertCountDown(countDownETA);

  const { confirmed, paid } = paymentState;

  const isConfirmed = !!confirmed || !!paid;

  const isCountDownExpiring = seconds + minutes * 60 <= 60 * 5; //Se è meno di 5 minuti
  let countDownText =
    "Il tuo posto è riservato. Concludi la prenotazione entro i prossimi";
  let variant = "yellow";

  switch (props.activeStep) {
    case stepsByName.CUSTOMER_DATA:
      break;
    case stepsByName.BONUS:
      countDownText =
        "Ti abbiamo bloccato il posto nel soggiorno e sull'eventuale viaggio, non perdere la priorità acquisita";
      variant = "orange";
      break;
    case stepsByName.INFORMATION:
      break;
    case stepsByName.EXTRA_SERVICES:
    /*countDownText = 'Ti abbiamo bloccato il posto nel soggiorno e sul volo, non perdere la priorità acquisita';
        bgColor = '#ffa500';
        break;*/
    case stepsByName.RECAP:
  }

  if (isCountDownExpiring) {
    countDownText =
      "Affrettati a concludere la prenotazione per non cedere il posto ad altri partecipanti in coda";
    variant = "red";
    // Color = '#FFFFFF';
  }

  if (isConfirmed) {
    return null;
  }

  return (
    <Alert
      id="countdown-timer"
      className={`${classes.alertIcon} ${
        isCountDownExpiring ? " countdown-blinking " : ""
      } ${variant}`}
      variant="filled"
      icon={<ClockIcon fontSize="inherit" />}
    >
      <Grid container spacing={1} direction="column">
        <Typography variant={"h6"} className={classes.noMargin}>
          {countDownText}
        </Typography>
        {!isCountDownExpiring && (
          <p className="counter-times">
            {String(minutes).padStart(2, "0")}:
            {String(seconds).padStart(2, "0")}
          </p>
        )}
      </Grid>
    </Alert>
  );
}

GlobalAlertTimer.propTypes = {};

export default GlobalAlertTimer;
